import React from 'react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE } from '../data/hero';
export function FinalCTA() {
  return <section aria-label="Get the system" className="bg-obsidian text-white" data-id="element-70" data-mp="3udoz2oyozioy">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 text-center lg:grid-cols-2 lg:py-24 lg:text-left" style={{
      paddingTop: "23px",
      paddingBottom: "33px"
    }} data-id="element-71" data-mp="c70vj3jaj3le">
        <div data-id="element-72" data-mp="m4f28bfewe0i">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.92] sm:text-7xl" data-id="element-73" data-mp="m46okhbgt4o9">
            Train smarter.
            <br data-id="element-74" data-mp="h5c6jhlbnk57" />
            Fuel better.
            <br data-id="element-75" data-mp="vui5r5k5tad3" />
            <span className="text-electric" data-id="element-76" data-mp="vv1bzp0g6aba">Execute with confidence.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-md text-lg text-white/70 lg:mx-0" data-id="element-77" data-mp="qv577njxeeuo">
            One system to organize the entire journey from training to finish line.
          </p>
          <div className="mt-8 flex justify-center lg:justify-start" data-id="element-78" data-mp="14t3i2iz1ft5f">
            <CTAButton href="#pricing" data-id="element-79" data-mp="zxxxbnhdgkix">Get the full system</CTAButton>
          </div>
          <p className="mt-3 text-xs text-white/50" data-id="element-80" data-mp="2c5y9blu6mfcu">$27 USD · One-time payment · 7-day guarantee</p>
        </div>
        <img src={PRODUCT_IMAGE} alt="THE FULL DISTANCE TRIATHLON SYSTEM™ with its four performance tools" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto h-auto w-full max-w-[560px]" data-id="element-81" data-mp="2h49hls4twhsy" />
      </div>
    </section>;
}